import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FuelDatePicker } from '@frete.com/fuel-react';
import { FieldDatePropsInterface } from './FieldDateTypes';

function FieldDate({ flow }: FieldDatePropsInterface) {
  const { control, clearErrors, formState, trigger, watch } = useFormContext();
  const [errorMessage, setErrorMessage] = useState('');
  const nameFieldDate = `waypoints.${flow}.date`;
  let labelDateField = 'Data de coleta';
  const valueDatePickup = watch('waypoints.pickup.date');

  function handleDate(event: {
    detail: {
      component: 'fuel-date-picker';
      value: string;
    };
  }) {
    const { value } = event.detail;

    clearErrors('waypoints.pickup.date');
    clearErrors('waypoints.delivery.date');

    return value;
  }

  if (flow === 'delivery') {
    labelDateField = 'Data de entrega';
  }

  useEffect(() => {
    const errorDate = (formState.errors?.waypoints?.[flow]?.date?.message ||
      '') as string;

    setErrorMessage(errorDate);
  }, [formState]);

  useEffect(() => {
    trigger('waypoints.delivery.date');
  }, [valueDatePickup]);

  return (
    <Controller
      name={nameFieldDate}
      control={control}
      render={({ field: { onBlur, onChange, value } }) => (
        <FuelDatePicker
          name={nameFieldDate}
          direction="left"
          data-testid={`input-${nameFieldDate}`}
          label={labelDateField}
          onFuel-blur={onBlur}
          onFuel-input={(event) => onChange(handleDate(event))}
          onFuel-change={(event) => {
            onChange(handleDate(event));
            onBlur();
          }}
          value={value}
          state={errorMessage ? 'error' : 'default'}
          hint={errorMessage}
        />
      )}
      defaultValue=""
    />
  );
}

export default FieldDate;
